<template>
    <v-dialog v-model="dialog" max-width="690" :persistent="[ 'success', 'loading' ].includes(addTransactionState)" @click:outside="clearCountDownCloseModal()">
        <v-card class="standard-row dialog-create-doc-card">
            <v-row no-gutters class="standard-row" style="padding: 29px 4% 5px 4%;">
                <v-col cols="12" sm="auto" md="auto" lg="auto" class="pr-sm-3 set-center-document-modal">
                    <svg width="35" class="mt-1" height="35" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.35272 3.00781H2.88792C2.29585 3.00781 1.72803 3.22892 1.30937 3.62249C0.890717 4.01607 0.655518 4.54987 0.655518 5.10647V28.1917C0.655518 28.7482 0.890717 29.2821 1.30937 29.6756C1.72803 30.0692 2.29585 30.2903 2.88792 30.2903H25.2119C25.804 30.2903 26.3718 30.0692 26.7905 29.6756C27.2091 29.2821 27.4443 28.7482 27.4443 28.1917V5.10647C27.4443 4.54987 27.2091 4.01607 26.7905 3.62249C26.3718 3.22892 25.804 3.00781 25.2119 3.00781H20.7471" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.0499 11.4015V24.1109M20.7471 17.6974H7.35266M9.58506 0.908203H18.5147C19.1067 0.908203 19.6745 1.12931 20.0932 1.52288C20.5119 1.91646 20.7471 2.45026 20.7471 3.00686C20.7471 3.56345 20.5119 4.09725 20.0932 4.49083C19.6745 4.8844 19.1067 5.10551 18.5147 5.10551H9.58506C8.99299 5.10551 8.42517 4.8844 8.00652 4.49083C7.58786 4.09725 7.35266 3.56345 7.35266 3.00686C7.35266 2.45026 7.58786 1.91646 8.00652 1.52288C8.42517 1.12931 8.99299 0.908203 9.58506 0.908203V0.908203Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" lg="auto" class="font-theme font-size-header-confirm-create set-center-document-modal">
                    Create Purchase Requisition
                </v-col>
            </v-row>
            <v-row class="standard-row" style="padding: 0 4%;">
                <v-card class="standard-row elevation-0 scroll-create-purchase-modal" style="background-color: rgba(217, 217, 217, 0.44); border-radius: 0px; min-height: 263px;">
                    <template v-if="addTransactionState === 'waiting'">
                        <v-row v-show="attachFile.length" no-gutters align="center" class="standard-row font-theme pt-5 pl-5 pr-5" :class="{ 'pb-5' :  indexFile === attachFile.length - 1}" v-for="(files, indexFile) in attachFile" :key="`${files}${indexFile}`" style="font-size: 24px; font-weight: 400;">
                            <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M26 20.5V9.125L17.0714 1H8.14284C7.19564 1 6.28723 1.34241 5.61746 1.9519C4.94769 2.5614 4.57141 3.38805 4.57141 4.25V20.5C4.57141 21.362 4.94769 22.1886 5.61746 22.7981C6.28723 23.4076 7.19564 23.75 8.14284 23.75H22.4286C23.3758 23.75 24.2842 23.4076 24.9539 22.7981C25.6237 22.1886 26 21.362 26 20.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1 4.25V20.5C1 22.2239 1.75255 23.8772 3.09209 25.0962C4.43164 26.3152 6.24845 27 8.14286 27H22.4286M17.0714 1V5.875C17.0714 6.73695 17.4477 7.5636 18.1175 8.1731C18.7872 8.78259 19.6957 9.125 20.6429 9.125H26" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="pl-2" style="font-size: 18px;">{{ files.name.substr(0, files.name.lastIndexOf(".")).length > 50? `${files.name.substr(0, files.name.lastIndexOf(".")).substring(0, 25)} . . . ${files.name.substr(0, files.name.lastIndexOf(".")).substring(files.name.substr(0, files.name.lastIndexOf(".")).length - 25)}`: files.name.substr(0, files.name.lastIndexOf(".")) }}</span>
                        </v-row>
                        <v-row v-show="!attachFile.length" no-gutters align="center" class="standard-row font-theme px-5 py-5" style="font-size: 24px; font-weight: 400;">
                            <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M26 20.5V9.125L17.0714 1H8.14284C7.19564 1 6.28723 1.34241 5.61746 1.9519C4.94769 2.5614 4.57141 3.38805 4.57141 4.25V20.5C4.57141 21.362 4.94769 22.1886 5.61746 22.7981C6.28723 23.4076 7.19564 23.75 8.14284 23.75H22.4286C23.3758 23.75 24.2842 23.4076 24.9539 22.7981C25.6237 22.1886 26 21.362 26 20.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1 4.25V20.5C1 22.2239 1.75255 23.8772 3.09209 25.0962C4.43164 26.3152 6.24845 27 8.14286 27H22.4286M17.0714 1V5.875C17.0714 6.73695 17.4477 7.5636 18.1175 8.1731C18.7872 8.78259 19.6957 9.125 20.6429 9.125H26" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="pl-2" style="font-size: 18px;">ไม่มีไฟล์แนบ</span>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-row no-gutters class="standard-row">
                            <sweetalert-icon :icon="addTransactionState"/>
                        </v-row>
                        <template v-if="addTransactionState === 'success'">
                            <v-row no-gutters class="standard-row font-theme d-flex justify-center animate-show-card">
                                <span style="font-size: calc(100% + 0.84vw);">ดำเนินการสำเร็จ</span>
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme d-flex justify-center animate-show-card" style="margin: 20.325px 0px;">
                                <span style="font-size: calc(100% + 0.4vw);">เลขเอกสาร : {{ aboutTransaction.document_id }}</span>
                            </v-row>
                        </template>
                        <template v-else-if="addTransactionState === 'loading'">
                            <v-row no-gutters class="standard-row font-theme d-flex justify-center">
                                <span style="font-size: calc(100% + 0.84vw);">กำลังดำเนินการ . . .</span>
                            </v-row>
                        </template>
                        <template v-else>
                            <v-row no-gutters class="standard-row font-theme d-flex justify-center animate-show-card">
                                <v-row class="standard-row font-theme d-flex justify-center">
                                    <span style="font-size: calc(100% + 0.84vw);" class="text-center">{{ error }}</span>
                                </v-row>
                                <v-row v-if="error === 'งบไม่ประมาณคงเหลือไม่เพียงพอ'" class="standard-row font-theme d-flex justify-center">
                                    <span style="font-size: calc(100% + 0.5vw);" class="text-center pt-3">. . . กลับไปหน้ากรอกข้อมูลภายใน {{ countTimeForCloseModal }} วินาที</span>
                                </v-row>
                            </v-row>
                        </template>
                    </template>
                </v-card>
            </v-row>
            <v-row class="standard-row text-center d-flex justify-center create-document-row">
                <v-btn height="31" color="#0B68D6" :disabled="addTransactionState === 'loading'" @click="createDocument()" class="font-theme white--text" style="box-shadow: none;">
                    {{ textInButton() }}
                </v-btn>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
    export default {
        data: () => ({
            error: '',
            jsonData: {},
            dialog: false,
            attachFile: [],
            transactionDetail: '',
            aboutTransaction: {},
            countTimeForCloseModal: 0,
            downloadTimerCloseModal: null,
            addTransactionState: 'waiting'
        }),
        mounted () {
            EventBus.$on('confirmCreatePurchaseRequisition', this.openDialog)
        },
        beforeDestroy () {
            EventBus.$off('confirmCreatePurchaseRequisition')
        },
        methods: {
            openDialog(body = {}, files = [], transactionDetail = {}) {
                this.jsonData            = body
                this.attachFile          = files
                this.dialog              = true
                this.transactionDetail   = transactionDetail
                this.addTransactionState = 'waiting'
            },
            async createDocument() {
                if (this.addTransactionState === 'success') {
                    return this.$router.push('/inbox')
                } else if (this.addTransactionState === 'error' && this.error === 'อับโหลดไฟล์แนบไม่สำเร็จ') {
                    return this.uploadAttachFile(this.aboutTransaction.transaction_id)
                } else if (this.addTransactionState === 'error' && this.error === 'งบไม่ประมาณคงเหลือไม่เพียงพอ') {
                    EventBus.$emit('backToPageGetDetailMemo')
                    this.dialog = false
                    clearInterval(this.downloadTimerCloseModal);
                    return
                }
                try {
                    this.addTransactionState = 'loading'
                    if (this.transactionDetail?.transaction_id) {
                        var { data } = await this.axios.put(`${this.$api_url}/transaction/api/v1/edit_transaction/${this.transactionDetail.transaction_id}`, this.jsonData)
                    } else {
                        var { data } = await this.axios.post(`${this.$api_url}/transaction/api/v1/add_transaction`, this.jsonData)
                    }
                    if(data.status) {
                        if (data.message === "edit transaction success" || data.message === "add transaction success") {
                            if (Object.keys(this.transactionDetail).length) {
                                this.aboutTransaction = this.transactionDetail
                                if (this.attachFile.length) {
                                    const tempAttachFile = this.attachFile.filter(e => !e.file_id)
                                    if (tempAttachFile.length) {
                                        return this.uploadAttachFile(tempAttachFile, this.transactionDetail?.transaction_id)
                                    }
                                }
                            } else {
                                this.aboutTransaction = {
                                    "document_id"    : data.data.document_id    || 'ไม่พบหมายเลขแบบฟอร์ม',
                                    "transaction_id" : data.data.transaction_id || ''
                                }
                                if (this.attachFile.length) {
                                    return this.uploadAttachFile(this.attachFile, data.data.transaction_id)
                                }
                            }
                            this.addTransactionState = 'success'
                        } else if (data.message === "insufficient balance" || data.message === "insufficient budget balance") {
                            this.addTransactionState = 'error'
                            this.error = 'งบประมาณคงเหลือไม่เพียงพอ'
                            this.countDownForCloseModal()
                        } else if (data.message === 'qt number is duplicated') {
                            this.addTransactionState = 'error'
                            this.error = 'สร้างแบบฟอร์มไม่สำเร็จ Qt Number ซ้ำในระบบ'
                            this.countDownForCloseModal()
                        } else {
                            this.addTransactionState = 'error';
                            this.error = data.message;
                            this.countDownForCloseModal();
                        }
                    } else {
                        throw new Error()
                    }
                } catch (error) {
                    this.addTransactionState = 'error'
                    this.error = 'สร้างแบบฟอร์มไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
                }
            },
            async uploadAttachFile(files = [], transactionId = '') {
                if (!transactionId || !files.length) {
                    this.addTransactionState = 'error'
                    return this.error = 'อับโหลดไฟล์แนบไม่สำเร็จ'
                }
                try {
                    this.addTransactionState = 'loading'
                    let formData = new FormData()
                    formData.append('transaction_id', transactionId)
                    for (let i = 0; i < files.length; i++) {
                        formData.append('file', files[i])
                    }
                    const { data } = await this.axios.post(`${this.$api_url}/attach_file/api/v1/save_file`, formData)
                    if(data.status) {
                        this.addTransactionState = 'success'
                    } else {
                        this.addTransactionState = 'error'
                        this.error = 'อับโหลดไฟล์แนบไม่สำเร็จ'
                    }
                } catch (error) {
                    console.log(error)
                    this.addTransactionState = 'error'
                    this.error = 'อับโหลดไฟล์แนบไม่สำเร็จ'
                }
            },
            textInButton() {
                if (this.addTransactionState === 'success') {
                    return 'กลับสู่หน้ากล่องเอกสาร'
                } else if (this.addTransactionState === 'error') {
                    if (this.error === 'งบไม่ประมาณคงเหลือไม่เพียงพอ') {
                        return 'กลับสู่หน้ากล่องเอกสาร'
                    } else {
                        return 'ส่งใหม่อีกครั้ง'
                    }
                } else {
                    return 'ส่งเอกสาร'
                }
            },
            countDownForCloseModal() {
                this.countTimeForCloseModal = 5
                this.downloadTimerCloseModal = setInterval(() => {
                    if(this.countTimeForCloseModal === 0){
                        clearInterval(this.downloadTimerCloseModal);
                        EventBus.$emit('backToPageGetDetailMemo')
                        this.dialog = false
                    } else {
                        this.countTimeForCloseModal--
                    }
                }, 1000);
            },
            clearCountDownCloseModal() {
                clearInterval(this.downloadTimerCloseModal);
            }
        }
    }
</script>

<style>
    .font-size-header-confirm-create {
        font-size: calc(100% + 1.1vw) !important;
        font-weight: 400;
    }

    .dialog-create-doc-card {
        background-color: white;
        border-radius: 20px !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
    }

    .success-transaction-header {
        font-size: 32px;
        font-weight: 400;
    }

    .success-transaction-body {
        font-size: 24px;
        font-weight: 400;
    }

    .create-document-row {
        padding-top: 17px;
        padding-bottom: 20px;
    }

    .close-btn {
        border-radius: 11px;
        font-size: 26px;
        font-weight: 400;
    }

    .scroll-create-purchase-modal {
        max-height: calc(100vh - 254px);
        min-height: 254px !important;
        overflow-y: auto;
        border-radius: 20px !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar {
        width: 12px;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar {
        width: 8px;
        background-color: transparent !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #D9D9D9;
    }

    @media only screen and (max-width: 600px) {
        
        .set-center-document-modal {
            text-align: center;
        }
    }
</style>